import {createReducer, on} from '@ngrx/store';
import {LoadableComponent} from '../../../projects/layout/src/_interface/loadableComponent';
import * as fromModal from 'app/_actions/modal.actions';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {IMedicineModalPayload} from 'app/_interfaces/modal-open-payload.interface';

export const modalFeatureKey = 'modal';

export interface ModalState {
	component: LoadableComponent;
	modalOptions: NgbModalOptions;
	openPayload: IMedicineModalPayload;
	closePayload: any;
}

export const initialState: ModalState = {
	component: null,
	modalOptions: {windowClass: 'modal-transparent', centered: true, backdrop: 'static'},
	openPayload: null,
	closePayload: null
};


export const reducer = createReducer(
	initialState,
	on(fromModal.openModalComponent, (state: ModalState, {component, modalOptions, openPayload}) => ({
		...state,
		component,
		modalOptions: modalOptions || state.modalOptions,
		openPayload,
		closePayload: null
	})),
	on(fromModal.closeModalComponent, (state: ModalState, {closePayload}) => ({
		...state,
		component: null,
		modalOptions: initialState.modalOptions,
		openPayload: null,
		closePayload
	}))
);

